// extracted by mini-css-extract-plugin
export default {"moveToFolder___tree":"MoveToFolder_moveToFolder___tree__df1Hf"};